import React, { useContext } from 'react';
import { Environment } from 'src/Environment';

import {
  paymentsDashboardRoute,
  postLogoutRoute,
  documentsRoute,
  productsAndServicesRoute,
  merchantProfileRoute,
  terminalsRoute,
  transactionsRoute,
  terminalTransactionsRoute,
  businessCashAdvancePreApprovedRoute,
  businessCashAdvanceApprovedRoute,
  businessCashAdvanceCalculationRoute,
  businessCashAdvanceDigitalTermsRoute,
  businessCashAdvanceRoute,
  businessCashAdvanceNoQualifyRoute,
  businessCashAdvanceDashboardRoute,
  bizWalletProDashboardRoute,
  bizWalletProTransactionsRoute,
  vodapayDealsRoute,
  generatePaymentRequestRoute,
  businessCashAdvanceTopUpCalculationRoute,
  businessCashAdvanceTopUpContractRoute,
} from 'src/routing/routes';
import { NavContext } from 'src/context/nav-context';
import { logout } from 'src/services/user.service';
import { SideNavItem } from 'src/components';
import { OfferContext } from 'src/context/offer-context';
import toastMessageServiceSingleton from 'src/services/toast-message.service';
import { VodapayLogoWithTextV2 } from 'src/assets/images';
import useTechnicalErrorHandler from 'src/hooks/useTechnicalError';
import './side-nav.scss';

export default function SideNav() {
  const { showNav, setShowNav } = useContext(NavContext);
  const { offers } = useContext(OfferContext);
  const { handleTechnicalError } = useTechnicalErrorHandler();

  let bcaRoute;

  if (offers?.offerDetails?.CurrentBalance && offers?.offerDetails?.CurrentBalance > 0) {
    bcaRoute = businessCashAdvanceDashboardRoute;
  } else if (offers?.offerDetails?.QualificationStatus === 1) {
    bcaRoute = businessCashAdvancePreApprovedRoute;
  } else {
    bcaRoute = businessCashAdvanceNoQualifyRoute;
  }

  return (
    <aside className="menu SideNav">
      <ul className={`menu-list side-nav ${showNav ? '' : 'side-nav-closed'}`}>
        <div className="header-container is-vcentered">
          <img className="vodapay-logo" src={VodapayLogoWithTextV2} />
          <span
            onClick={() => {
              setShowNav(!showNav);
            }}
            className="close-icon is-icon-5 icon-cross-thin is-hidden-tablet"
            automationid="Menu_Side_Nav_Div_Button_Close_Side_Nav"
          ></span>
        </div>
        <SideNavItem
          name="Payment services"
          route={paymentsDashboardRoute}
          iconName="icon-calculator"
          className="top-level-link"
          subRoutes={[terminalsRoute, transactionsRoute, terminalTransactionsRoute]}
          automationid="Menu_Side_NavItem_Payment_Services"
        >
          <ul>
            <SideNavItem
              name="Terminals"
              route={terminalsRoute}
              className="bullet-point"
              isSubItem={true}
              automationid="Menu_Side_NavItem_Terminals"
            />
            <SideNavItem
              name="Account transactions"
              route={transactionsRoute}
              className="bullet-point last-child"
              isSubItem={true}
              automationid="Menu_Side_NavItem_Transactions"
            />
            <div className="sub-border last-border" />
            <SideNavItem
              name="Terminal transactions"
              route={terminalTransactionsRoute}
              className="bullet-point"
              isSubItem={true}
              automationid="Menu_Side_NavItem_Terminal_Transactions"
            />
          </ul>
        </SideNavItem>
        {!Environment.current?.disabledFeatures?.paymentRequest && (
          <SideNavItem
            iconName="icon-make-payment"
            name="Generate Payment Request"
            route={generatePaymentRequestRoute}
            className="top-level-link"
            automationid="Menu_Side_NavItem_VodaPay_Deals"
          />
        )}
        {!Environment.current?.disabledFeatures?.sovDashboard && (
          <SideNavItem
            name="BizWallet Pro"
            route={bizWalletProDashboardRoute}
            iconName="icon-wallet"
            className="top-level-link"
            subRoutes={[bizWalletProTransactionsRoute]}
            automationid="Menu_Side_NavItem_Biz_Wallet_Pro_Dashboard"
          >
            <ul>
              <SideNavItem
                name="Transactions"
                route={bizWalletProTransactionsRoute}
                className="bullet-point"
                isSubItem={true}
                automationid="Menu_Side_NavItem_Biz_Wallet_Pro_Transactions"
              />
            </ul>
          </SideNavItem>
        )}
        <SideNavItem
          iconName="icon-megaphone"
          name="VodaPay Deals"
          route={vodapayDealsRoute}
          className="top-level-link"
          automationid="Menu_Side_NavItem_VodaPay_Deals"
        />
        <SideNavItem
          name="Get financed"
          route={businessCashAdvanceRoute}
          iconName="icon-hand-cash"
          className="top-level-link"
          subRoutes={[
            businessCashAdvancePreApprovedRoute,
            businessCashAdvanceApprovedRoute,
            businessCashAdvanceCalculationRoute,
            businessCashAdvanceDashboardRoute,
            businessCashAdvanceDigitalTermsRoute,
            businessCashAdvanceNoQualifyRoute,
            businessCashAdvanceTopUpCalculationRoute,
            businessCashAdvanceTopUpContractRoute,
          ]}
          onClick={() => setShowNav(false)}
          automationid="Menu_Side_NavItem_Get_Financed"
        >
          {!Environment.current?.disabledFeatures?.bca && (
            <ul>
              <SideNavItem
                name="Business Cash Advance"
                route={bcaRoute}
                activeRoutes={[
                  businessCashAdvancePreApprovedRoute,
                  businessCashAdvanceApprovedRoute,
                  businessCashAdvanceDashboardRoute,
                  businessCashAdvanceCalculationRoute,
                  businessCashAdvanceDigitalTermsRoute,
                  businessCashAdvanceNoQualifyRoute,
                  businessCashAdvanceTopUpCalculationRoute,
                  businessCashAdvanceTopUpContractRoute,
                ]}
                className="bullet-point"
                isSubItem={true}
                onClick={() => setShowNav(false)}
                automationid="Menu_Side_NavItem_Business_Cash_Advance"
              />
            </ul>
          )}
        </SideNavItem>
        <SideNavItem
          iconName="icon-document"
          name="My documents"
          route={documentsRoute}
          className="top-level-link"
          automationid="Menu_Side_NavItem_My_Documents"
        />
        {!Environment.current?.disabledFeatures?.valueAddedServices && (
          <SideNavItem
            iconName="icon-products-and-services-icon"
            name="Products and services"
            route={productsAndServicesRoute}
            className="top-level-link"
            automationid="Menu_Side_NavItem_Products_And_Services"
          />
        )}
        <SideNavItem
          iconName="icon-user"
          name="My profile"
          route={merchantProfileRoute}
          className="top-level-link"
          automationid="Menu_Side_NavItem_My_Profile"
        />
        <SideNavItem
          iconName="icon-logout-right"
          name="Logout"
          route={postLogoutRoute}
          onClick={() => {
            toastMessageServiceSingleton.removeAllToasts();
            logout(handleTechnicalError, true);
          }}
          className="top-level-link"
          automationid="Menu_Side_NavItem_Logout"
        />
      </ul>
    </aside>
  );
}
